const components = {
  MuiButton: {
    styleOverrides: {
      root: {
        borderRadius: 0,
        padding: "14px 36px",
      },
    },
  },

  MuiContainer: {
    defaultProps: {
      maxWidth: "lg",
    },
  },
};

export default components;
